import React from 'react';
import { FieldSelect } from '../../components';

import css from './EditListingDescriptionForm.module.css';

const CustomTrackSelectFieldMaybe = props => {
const { name, id, trackOptions, intl } = props;
const trackLabel = intl ? intl.formatMessage({
    id: 'EditListingDescriptionForm.trackLabel',
  }) : "What track are you on?";

  return trackOptions ? (
    <FieldSelect className={css.service} name={name} id={id} label={trackLabel} validate={props.validate}>
      <option key="placeholder" value="" disabled selected hidden>
        {"Select track..."}
      </option>
      {trackOptions.map(c => (
        <option key={c.key} value={c.key} >
          {c.label}
        </option>
      ))}
    </FieldSelect>
  ) : null;
};

export default CustomTrackSelectFieldMaybe;
